module.exports = __webpack_public_path__ + "static/media/fig_24a.6f59451e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_24a.jpg
// module id = 662
// module chunks = 0